import React from "react";

const Preloader = () => {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#f7f2ea]">
      <div className="flex flex-col items-center gap-4">
        {/* Spinner */}
        <div className="h-14 w-14 rounded-full border-4 border-accent/40 border-t-accent animate-spin" />

        {/* Text */}
        <p className="text-primary font-semibold tracking-wide">
          Loading Cire Legal...
        </p>
      </div>
    </div>
  );
};

export default Preloader;
